import { Injectable } from '@angular/core';
import {Observable} from "rxjs";
import {emptyMockData, emptyMockUrl, IMockData, IMockUrl} from "@retail-data-factory/rdf-angular-types-api";
import {map} from "rxjs/operators";
import {DataService} from "../../../../services/external-api/data.service";
import {ConfigurationManager} from "../../../../store/configuration-manager/configuration-manager";
import {IServiceResponse} from "../../../../services/external-api/response-interfaces";

@Injectable({
  providedIn: 'root'
})
/**
 * Сервис работы с Mock сервером
 */
export class ApiMockService {

  constructor(private dataService: DataService,
              private configurationManager: ConfigurationManager) { }

  /**
   * Получить список URL
    */
  getUrls():Observable<Array<IMockUrl>>{
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiMock')}/url`, {}).pipe(
      map(result => {
        const mocks: Array<IMockUrl> = result.report.map(item => this.mapUrlFromService(item));
        return mocks;
      })
    );
  }

  /**
   * Получить URL по ID
   * @param id
   */
  getUrl(id: string): Observable<IMockUrl> {
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiMock')}/url/${id}`, {}).pipe(
      map(result => {
        if (result && result.report.length) {
          const mock:IMockUrl = this.mapUrlFromService(result.report[0]);
          return mock;

        }
        return null;
      })
    );
  }

  /**
   * Создать новый URL
   * @param url
   */
  createUrl(url: IMockUrl): Observable<IServiceResponse> {
    return this.dataService.postData(`${this.configurationManager.getApiUrl('apiMock')}/url`, {}, this.mapUrlToService(url));

  }

  /**
   * Обновить URL
   * @param url
   */
  updateUrl(url: IMockUrl): Observable<IServiceResponse> {
    return this.dataService.putData(`${this.configurationManager.getApiUrl('apiMock')}/url/${url.id}`, {}, this.mapUrlToService(url));
  }

  /**
   * Сохранить (создать или обночить) URL
   * @param url
   */
  saveUrl(url: IMockUrl): Observable<IServiceResponse> {
    return url.id?this.updateUrl(url): this.createUrl(url);
  }

  /**
   * Удалить URL
   * @param id
   */
  deleteUrl(id: string): Observable<IServiceResponse> {
    return this.dataService.deleteData(`${this.configurationManager.getApiUrl('apiMock')}/url/${id}`, {});
  }


  /**
   * Получить список Mock данных
   */
  getDatas():Observable<Array<IMockData>>{
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiMock')}/data`, {}).pipe(
      map(result => {
        const mocks: Array<IMockData> = result.report.map(item => this.mapDataFromService(item));
        return mocks;
      })
    );
  }

  /**
   * Получить mock данные по ID
   * @param id
   */
  getData(id: string): Observable<IMockData> {
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiMock')}/data/${id}`, {}).pipe(
      map(result => {
        if (result && result.report.length) {
          const mock:IMockData = this.mapDataFromService(result.report[0]);
          return mock;

        }
        return null;
      })
    );
  }

  /**
   * Создать новые mock данные
   * @param data
   */
  createData(data: IMockData): Observable<IServiceResponse> {
    return this.dataService.postData(`${this.configurationManager.getApiUrl('apiMock')}/data`, {}, this.mapDataToService(data));

  }

  /**
   * Обновить mock данные
   * @param data
   */
  updateData(data: IMockData): Observable<IServiceResponse> {
    return this.dataService.putData(`${this.configurationManager.getApiUrl('apiMock')}/data/${data.id}`, {}, this.mapDataToService(data));

  }

  /**
   * Сохранить (создать или обновить) mock данные
   * @param data
   */
  saveData(data: IMockData): Observable<IServiceResponse> {
    return data.id?this.updateData(data): this.createData(data);
  }

  /**
   * Удалить mock данные по ID
   * @param id
   */
  deleteData(id: string): Observable<IServiceResponse> {
    return this.dataService.deleteData(`${this.configurationManager.getApiUrl('apiMock')}/data/${id}`, {});
  }



  private mapUrlFromService(item: object):IMockUrl {
    const mockUrl: IMockUrl = {
      ...emptyMockUrl,
      id: item['id']?item['id'].toString(): '',
      url: item['url']?item['url']: '',
      name: item['name']?item['name']: '',
      description: item['description']?item['description']: '',
      script: item['script']?item['script']: '',
      profile: item['profile']
    };
    return mockUrl;
  }

  private mapDataFromService(item: object):IMockData {
    const mockData: IMockData = {
      ...emptyMockData,
      id: item['id']?item['id'].toString(): '',
      code: item['code']?item['code']: '',
      name: item['name']?item['name']: '',
      description: item['description']?item['description']: '',
      profile: item['profile']?JSON.stringify(item['profile'],undefined,4):'{}'
    };
    return mockData;
  }

  private mapUrlToService(url: IMockUrl):object {
    return {
      "url": url.url,
      "name": url.name,
      "description": url.description,
      "script": url.script,
      "profile": url.profile
    };
  }
  private mapDataToService(data: IMockData): object {
    return {
      "code": data.code,
      "name": data.name,
      "description": data.description,
      "profile": JSON.parse(data.profile)
    };
  }

}
